import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Router } from '@angular/router';

@Injectable()
export class MatPaginatorIntlBr extends MatPaginatorIntl {
  firstPageLabel = 'Primeira página';
  lastPageLabel = 'Última página';
  itemsPerPageLabel = 'Itens por página: ';
  nextPageLabel = 'Próxima página';
  previousPageLabel = 'Página anterior';
  private itemType: string = 'ordens';

  constructor(private router: Router) {
    super();
  }

  setItemType(type: string) {
    this.itemType = type;
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return '0 de ' + length;
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;

    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `Exibindo ${endIndex} de ${length} ${this.itemType}`;
  };
}
